export default class Mechanims {
  // fork from https://github.com/jaredhanson/js-sasl-x-oauth2
  name = 'X-OAUTH'
  clientFirst = true
  constructor() {}
  response = (credentials: { token: string }) => {
    return credentials.token
  }
  challenge = () => {}
}
